import { Box } from "@mui/material";
import React, { useEffect } from "react";

import * as authService from "../../service/AuthService";
import * as apiService from "../../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ActionType } from "../../constants";
const GlobalHandler = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (auth.testing) return;
    if (auth.accountData.loginToken === null) {
      const {
        contactInfo,
        contactType,
        loginToken,
        firstName,
        lastName,
        accountType,
      } = authService.getUser();
      if (contactInfo && loginToken) {
        dispatch({
          type: ActionType.setUserData,
          payload: {
            contactInfo,
            contactType,
            loginToken,
            firstName,
            lastName,
            accountType,
          },
        });
        // disable when testing UI stuff
        apiService.getSurvey(
          dispatch,
          {
            contactInfo,
            contactType,
            loginToken,
            firstName,
            lastName,
          },
          () => {
            console.log("back ");
            authService.logout(navigate, dispatch);
          },
          () => {
            apiService.getNumUnread(
              dispatch,
              null,
              {
                contactInfo,
                contactType,
                loginToken,
              },
              {}
            );
          }
        );
      }
    }
  }, [auth.accountData.loginToken]);
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        position: "fixed",
      }}
    />
  );
};

export default GlobalHandler;
